/**
 * Languages Store
 * Manages languages data for filters
 */

import { create } from 'zustand';
import { fetchLanguages } from '../services/languages.service';
import { globalConfig } from '../config/globalConfig';
import type { Language } from '../interfaces/apiInterfaces/languages';

interface LanguagesStore {
  languages: Language[];
  isLoading: boolean;
  error: string | null;
  load: () => Promise<void>;
  reset: () => void;
}

export const useLanguagesStore = create<LanguagesStore>((set) => ({
  // Initial State
  languages: [],
  isLoading: false,
  error: null,

  // Actions
  load: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetchLanguages({ page_size: globalConfig.defaultPageSize });
      set({ languages: response.data, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load languages';
      set({ error: message, isLoading: false });
      console.error('Failed to load languages:', error);
    }
  },

  reset: () => set({ languages: [], isLoading: false, error: null }),
}));
